import { Fragment, PureComponent, createRef } from 'react';
import { isEmpty, values, compact, omit, assignWith } from 'lodash-es';

import PhoneInput from 'components/PhoneInput';
import Icon from 'components/Icon';
import Button from 'components/Button';

import {
  InputHasPasswordToggleLabelError,
  InputHasLabelError,
} from 'components/Input/InputVariants';

import { to } from 'helpers';
import { validateValues } from 'helpers/validation';

import { apiRegister } from 'constants/api';

class PersonalData extends PureComponent {
  state = { isValidated: false, isValid: this.props.isValid };

  passRef = createRef();

  handleEmailChange = e => {
    this.props.onValid(false);
    this.setState({ isValidated: false, isValid: false });

    this.props.onChange(e);
  };

  handleEmailBlur = async () => {
    if (this.props.isValid) {
      if (this.clicked) {
        this.handleContinueClick();
      }
      return;
    }

    if (this.state.isValidated) {
      await this.setState({ isValidated: false });
    }

    const errors = validateValues({ email: this.props.values.email });
    if (!isEmpty(errors)) return;

    const [err, data] = await to(
      apiRegister.checkEmail(
        { email: this.props.values.email },
        this.props.type
      )
    );

    this.setState({ isValidated: true }, () => {
      if (!err && this.clicked) {
        this.handleContinueClick();
        return;
      }

      this.props.onValid(false);
    });

    if (!err) return;

    const [{ field, message }] = err.response.data.message;
    this.props.renderError(field, message);
  };

  handleContinueClick = () => {
    const { firstName, lastName, email, phone, password } = this.props.values;

    const errors = validateValues({
      firstName,
      lastName,
      email,
      phone,
      password,
    });

    if (hasErrors(this.props.errors, errors)) {
      const allErrors = combineErrors(errors, this.props.errors);
      this.props.renderErrors(allErrors);
      return;
    }

    if (this.state.isValid) {
      this.props.toggle();
      return;
    }

    if (!this.state.isValidated) {
      this.clicked = true;
      return;
    }

    this.props.onValid(true);
    this.clicked = false;
    this.props.toggle();
  };

  render() {
    const { values, errors, onChange } = this.props;

    return (
      <Fragment>
        <div className="section__header-wrap _mb-39">
          <h2 className="title section__title _mb-21">Let's get started</h2>
          <p className="text section__text">
            Register now as a premium reseller.
          </p>
        </div>
        <div className="form__row form__row_flex _mb-17">
          <div className="form__col _mb-note-17">
            <InputHasLabelError
              name="firstName"
              placeholder="John"
              error={errors.firstName}
              value={values.firstName}
              onChange={onChange}
              label="First Name"
              labelClassName="_mb-7"
            />
          </div>
          <div className="form__col form__col_last">
            <InputHasLabelError
              name="lastName"
              placeholder="Doe"
              label="Last Name"
              error={errors.lastName}
              value={values.lastName}
              onChange={onChange}
              labelClassName="_mb-7"
            />
          </div>
        </div>
        <div className="form__row _mb-17">
          <PhoneInput
            placeholder="+1 234-567-8901"
            name="phone"
            error={errors.phone}
            onChange={onChange}
            value={values.phone}
            labelClassName="_mb-7"
            label="Phone"
          />
        </div>
        <div className="form__row _mb-17">
          <InputHasLabelError
            name="email"
            placeholder="email@example.com"
            error={errors.email}
            onChange={this.handleEmailChange}
            value={values.email}
            onBlur={this.handleEmailBlur}
            label="Email"
            labelClassName="_mb-7"
          />
        </div>
        <div className="form__row _mb-24">
          <InputHasPasswordToggleLabelError
            name="password"
            placeholder="Your new account password"
            className="input_password"
            buttonClassName="btn input__password-switch"
            value={values.password}
            error={errors.password}
            onChange={onChange}
            labelClassName="_mb-7"
            label="Password"
            innerRef={this.passRef}
            autoComplete="new-password"
          />
        </div>
        <Button
          className="btn_wide _mb-50"
          type="button"
          onClick={this.handleContinueClick}
        >
          Continue
          <Icon
            className="btn__icon-arrow btn__icon-arrow_right"
            icon="arrow-text-1"
          />
        </Button>
        <div className="form__switcher-wrap">
          <span className="btn_switcher btn_switcher_active btn_switcher_disabled" />
          <span
            className={cx('btn_switcher btn_switcher_last', {
              btn_switcher_disabled: !this.state.isValid,
            })}
            onClick={this.handleContinueClick}
          />
        </div>
      </Fragment>
    );
  }
}

export default PersonalData;

const hasErrors = (errors, nextErrors) => {
  const newErrors = !isEmpty(nextErrors);
  const previousCheckErrors = !isEmpty(
    compact(values(omit(errors, ['url', 'country', 'name'])))
  );

  return newErrors || previousCheckErrors;
};

const combineErrors = (errors, nextErrors) =>
  assignWith(errors, nextErrors, (prevValue, nextValue) =>
    nextValue.length ? nextValue : prevValue
  );
